import { render, staticRenderFns } from "./SfQuantitySelector.vue?vue&type=template&id=19836145&"
import script from "./SfQuantitySelector.vue?vue&type=script&lang=js&"
export * from "./SfQuantitySelector.vue?vue&type=script&lang=js&"
import style0 from "./SfQuantitySelector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports